import { keyframes, styled } from "@mui/material";
import { NotificationsActive } from "@mui/icons-material";

interface AnimatedBellProps {
    active?: boolean;
}

const shakeAnimation = keyframes`
  0% { transform: rotate(0deg); }
  20% { transform: rotate(-15deg); }
  40% { transform: rotate(15deg); }
  60% { transform: rotate(-15deg); }
  80% { transform: rotate(15deg); }
  100% { transform: rotate(0deg); }
`;

export const AnimatedBell = styled(NotificationsActive, {
    shouldForwardProp: (prop) => prop !== "active",
})<AnimatedBellProps>(({ theme, active }) => ({
    color: "#ff9800",
    fontSize: 30,

    animation: active ? `${shakeAnimation} 0.5s ease-in-out` : "none",

    display: "inline-block",
}));